import React, { useState, useEffect } from 'react';
import { HeroBannerWrapper } from '../layouts/HeroBannerWrapper/HeroBannerWrapper';
import { ReferenceCardSection } from '../layouts/ReferenceCardSection/ReferenceCardSection';
import { useContentfulEntries, BrandUtil, wineryDirectStates, usePageLayer } from 'dw-us-ui';
import { ButtonTabs } from '../components/ButtonTabs/ButtonTabs';
import { BackToTop } from '../components/BackToTop/BackToTop';
import { Loader } from '../components/Loader/Loader';
import { InfoSection } from '../layouts/InfoSection/InfoSection';
import { ButtonWithContentWrapper } from '../layouts/ButtonWithContentWrapper/ButtonWithContentWrapper';
import { ProductListing } from '../layouts/ProductListing/ProductListing';
import { BeyondTheLabel } from '../layouts/BeyondTheLabel/BeyondTheLabel';
import { StandardContentBlockWrapper } from '../layouts/StandardContentBlockWrapper/StandardContentBlockWrapper';
import { BeyondTheLabelMixed } from '../layouts/BeyondTheLabel/BeyondTheLabelMixed';

const ListPage = () => {
  const [isLoading, setLoading] = useState(true);
  const pageLayer = usePageLayer();
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  let contentReturn = useContentfulEntries({
    contentType: 'hubPage',
    environment: 'master',
    additionalFilters: {
      'fields.slug': 'list-page',
      'fields.brand': brandTag.toUpperCase(),
      'fields.wd': wineryDirectStates.includes(pageLayer?.stateCode),
    },
  });

  useEffect(() => {
    if (contentReturn) {
      setLoading(false);
    }
  }, [contentReturn]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const getComponentName = items => {
    const { fields, sys } = items;
    const type = fields?.module || sys?.contentType?.sys?.id;
    switch (type) {
      case 'image_with_content_block':
        return <InfoSection Header={fields?.title} infoBlocks={fields?.blocks} />;

      case 'card_block':
        return (
          <>
            <ReferenceCardSection header={fields?.title} cards={fields?.blocks} />
          </>
        );
      case 'button_with_content':
        return <ButtonWithContentWrapper fields={fields} />;
      case 'product':
        return fields?.type === 'add_to_card' ? (
          <ProductListing fields={fields} />
        ) : fields?.itemCode.startsWith('M') ? (
          <BeyondTheLabelMixed itemCode={fields?.itemCode} brand={contentReturn?.brand} />
        ) : (
          <BeyondTheLabel fields={fields} brand={contentReturn?.brand} />
        );
      case 'standard_content_block':
      case 'textBlockWithMobile':
        return <StandardContentBlockWrapper fields={fields} />;
      case 'hero_banner':
      case 'imageBlock':
        return <HeroBannerWrapper bannerContent={fields?.blocks || fields} />;
      case 'nav_tab':
        return <ButtonTabs navTab={fields?.blocks} />;

      default: {
        return null;
      }
    }
  };

  return (
    <div>
      {isLoading && <Loader />}
      {contentReturn && <HeroBannerWrapper bannerContent={contentReturn?.banner?.fields?.blocks} />}
      {contentReturn &&
        contentReturn?.section.length > 0 &&
        contentReturn?.section.map(items => {
          return getComponentName(items);
        })}
      <BackToTop />
    </div>
  );
};

export default ListPage;
